import * as Yup from "yup";
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { selectValidation, stringValidation } from "../providers/validations";
import Field from "../components/Field";
import { FileUpload, Select, Text } from "../inputs";
import { Form } from "../template";
import { SHA256 } from "crypto-js";
import { mainApi } from "../providers/api";
import objectPath from "object-path";

const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const props = {
    editable: true,
    isDeletable: true,
    model: "price",
    text: id ? "Үнэ-н мэдээлэл" : "Үнэ бүртгэх",
    id: id,
    init: {},
    validationSchema: Yup.object().shape({
      price: stringValidation(true),
      size: selectValidation(true),
      material: selectValidation(true),
    }),
  };
  const beforeSubmit = async (data) => {
    return data;
  };
  return (
    <Form {...props} beforeSubmit={beforeSubmit}>
      {({ submited, disabled, values }) => {
        return (
          <div className="p-5 bg-white  grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <Field
                name="material"
                label={t("price.material")}
                disabled={disabled}
                component={Select}
                axio={`/consts/select/material`}
                type="text"
              />
              <Field
                name="size"
                label={t("price.size")}
                disabled={disabled}
                component={Select}
                axio={`/consts/select/size`}
                type="text"
              />
            </div>
            <div className="flex flex-col gap-4">
              <Field
                name="price"
                label={t("price.price")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
              <Field
                name="coat"
                label={t("price.coat")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
            </div>
          </div>
        );
      }}
    </Form>
  );
};

export default UserForm;
